<div class="PGCallParticipant bg-dark">
    @if (!participant.local) {
        <div class="PGCallParticipant-Name m-1 px-1 bg-light small opacity-80">{{participant.participant.user_name}}</div>
    }
    <video #videoElement></video>
    <audio #audioElement></audio>
</div>
